import { render, staticRenderFns } from "./page-plan-details-v3.vue?vue&type=template&id=0d4615f3"
import script from "./page-plan-details-v3.js?vue&type=script&lang=js&external"
export * from "./page-plan-details-v3.js?vue&type=script&lang=js&external"
import style0 from "./page-plan-details-v3.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports